import {HttpRequestProvider} from "./HttpRequestContext";
import {NotificationConfigurationProvider} from "./NotificationConfigurationContext";
import React from "react";
import {ExceptionProvider} from "./ExceptionContext";
import {ActionTypeProvider} from "./ActionTypeContext";
import {ActionProvider} from "./ActionContext";
import {ApplicantProvider} from "./ApplicantContext";
import {RequestProvider} from "./RequestContext";
import {HolidayTypeProvider} from "./HolidayTypeContext";
import {SchoolYearProvider} from "./SchoolYearContext";
import {HolidayProvider} from "./HolidayContext";
import {ApplicationContextProvider} from "./ApplicationContext";
import {AuthenticationProvider} from "./AuthenticationContext";
import {RequesterSourceTypeProvider} from "./RequesterSourceTypeContext";
import {DispositionTypeProvider} from "./DispositionTypeContext";
import {ManageRequestProvider} from "./ManageRequestContext";

const AppProviders: React.FC<{children?: React.ReactNode}> =
    ({children}) => {
        return (
            <ApplicationContextProvider>
            <AuthenticationProvider>
            <HttpRequestProvider>
            <ApplicantProvider>
            <RequestProvider>
            <ManageRequestProvider>
            <RequesterSourceTypeProvider>
            <DispositionTypeProvider>
            <ActionProvider>
            <ActionTypeProvider>
            <NotificationConfigurationProvider>
            <HolidayTypeProvider>
            <SchoolYearProvider>
            <HolidayProvider>
            <ExceptionProvider>
                {children}
            </ExceptionProvider>
            </HolidayProvider>
            </SchoolYearProvider>
            </HolidayTypeProvider>
            </NotificationConfigurationProvider>
            </ActionTypeProvider>
            </ActionProvider>
            </DispositionTypeProvider>
            </RequesterSourceTypeProvider>
            </ManageRequestProvider>
            </RequestProvider>
            </ApplicantProvider>
            </HttpRequestProvider>
            </AuthenticationProvider>
            </ApplicationContextProvider>
        );
};

export default AppProviders;
